import StripeApplePayPaymentMethod from './StripeApplePayPaymentMethod';
import StripeCardPaymentMethod from './StripeCardPaymentMethod';
import AdyenKlarnaPaymentMethod from './AdyenKlarnaPaymentMethod';
import AdyenTokenizeCardPaymentMethod from './AdyenTokenizeCardPaymentMethod';
import AdyenAuthNowCardPaymentMethod from './AdyenAuthNowCardPaymentMethod';
import AdyenApplePayPaymentMethod from './AdyenApplePayPaymentMethod';


export default class PaymentMethodFactory {
  static for(paymentOption) {
    const option = $(paymentOption);
    const name = option.attr('value');
    const form = $(`#${name}-form`);

    const klass = {
      'stripe-apple-pay': StripeApplePayPaymentMethod,
      'stripe-card': StripeCardPaymentMethod,
      'adyen-klarna': AdyenKlarnaPaymentMethod,
      'adyen-tokenize-card': AdyenTokenizeCardPaymentMethod,
      'adyen-auth-now-card': AdyenAuthNowCardPaymentMethod,
      'adyen-apple-pay': AdyenApplePayPaymentMethod,
    }[name];
    return new klass(option, form);
  }
}
